<template lang='pug'>
pre {{ messages }}  
</template>

<script>
export default {
  props: ['messages']
}
</script>

